import React, { useEffect } from "react";
import { ThumbsUp, ThumbsDown, Send } from "lucide-react";
import { LoadingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

function SectionGeneratorFeedback({
  feedbackStates,
  section,
  handleInitialFeedback,
  generatedSections,
  setFeedbackStates,
  handleCommentSubmit,
}) {
  const isSubmitting = feedbackStates[section.id]?.isSubmitting;
  const isSubmitted = feedbackStates[section.id]?.isSubmitted;

  const currentFeedback = feedbackStates[section.id];
  const isThumbsUp = currentFeedback?.thumbs === true;
  const isThumbsDown = currentFeedback?.thumbs === false;

  useEffect(() => {
    let timer;

    if (isSubmitted) {
      timer = setTimeout(() => {
        setFeedbackStates((prev) => ({
          ...prev,
          [section.id]: {
            ...prev[section.id],
            isSubmitted: false,
          },
        }));
      }, 2000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isSubmitted, section.id, setFeedbackStates]);

  return (
    <div className="section_generator_panel_feedback">
      <div className="section_generator_panel_feedback_content">
        {!feedbackStates[section.id]?.showCommentBox && (
          <div className="section_generator_panel_feedback_actions">
            <Tooltip placement="bottom" title="Helpful">
              <button
                onClick={() =>
                  handleInitialFeedback(
                    section.id,
                    generatedSections.find((s) => s.id === section.id)?.chat_history_id,
                    true
                  )
                }
                className="section_generator_panel_feedback_button"
              >
                <ThumbsUp size={12} strokeWidth={2.5} color={"#0069a5"} fill={isThumbsUp ? "#0069a5" : "#ffffff"} />
              </button>
            </Tooltip>
            <Tooltip placement="bottom" title="Not helpful">
              <button
                onClick={() =>
                  handleInitialFeedback(
                    section.id,
                    generatedSections.find((s) => s.id === section.id)?.chat_history_id,
                    false
                  )
                }
                className="section_generator_panel_feedback_button"
              >
                <ThumbsDown
                  size={12}
                  strokeWidth={2.5}
                  color={"#0069a5"}
                  fill={isThumbsDown ? "#0069a5" : "#ffffff"}
                />
              </button>
            </Tooltip>
          </div>
        )}

        {feedbackStates[section.id]?.showCommentBox && (
          <div className="w-full mt-3 p-2 rounded-lg animate-in fade-in slide-in-from-top-1">
            <textarea
              disabled={isSubmitting}
              className="dialog-popup-custom-instructions-textarea"
              style={{
                paddingTop: "5px",
                minHeight: "60px",
                opacity: isSubmitting ? 0.6 : 1,
              }}
              placeholder="Help us improve this section..."
              value={feedbackStates[section.id]?.comment || ""}
              onChange={(e) =>
                setFeedbackStates((prev) => ({
                  ...prev,
                  [section.id]: { ...prev[section.id], comment: e.target.value },
                }))
              }
            />
            <div className="section_generator_panel_feedback_comment_actions">
              <Tooltip placement="bottom" title={isSubmitting ? "Submitting feedback..." : "Cancel Feedback"}>
                <button
                  disabled={isSubmitting}
                  onClick={() =>
                    setFeedbackStates((prev) => ({
                      ...prev,
                      [section.id]: {
                        ...prev[section.id],
                        showCommentBox: false,
                        comment: "",
                      },
                    }))
                  }
                  style={{
                    background: "none",
                    border: "none",
                    color: "#9ca3af",
                    fontSize: "10px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    fontWeight: "bold",
                    opacity: isSubmitting ? 0.5 : 1,
                  }}
                >
                  &times; Cancel
                </button>
              </Tooltip>
              <Tooltip placement="bottom" title={isSubmitting ? "Submitting feedback..." : "Submit Feedback"}>
                <button
                  disabled={isSubmitting}
                  onClick={() =>
                    handleCommentSubmit(section.id, generatedSections.find((s) => s.id === section.id)?.chat_history_id)
                  }
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#19a5cd";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#0069a5";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  style={{
                    backgroundColor: "#0069a5",
                    color: "#ffffff",
                    padding: "5px 12px",
                    borderRadius: "4px",
                    border: "none",
                    fontSize: "10px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.6 : 1,
                  }}
                >
                  {isSubmitting ? (
                    <>
                      <LoadingOutlined />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <Send size={10} />
                      Submit feedback
                    </>
                  )}
                </button>
              </Tooltip>
            </div>
          </div>
        )}

        {isSubmitted && (
          <div
            className="flex items-center gap-1.5 py-1 px-2 rounded text-[10px] font-medium animate-in fade-in"
            style={{ color: "#0069a5" }}
          >
            <div className="w-1 h-1 rounded-full bg-green-500" />
            Feedback received, thank you!
          </div>
        )}
      </div>
    </div>
  );
}

export default SectionGeneratorFeedback;
